<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light" class="mt-3">

                <b-row class="my-3 align-items-center">
                    <b-col cols='10'>
                    </b-col>
                    <b-col cols='2' class='d-flex justify-content-center align-items-center'>
                        <b-button id="localizar-solicitacao" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="load">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                            <b-tooltip target="localizar-solicitacao" title="Localizar"></b-tooltip>
                        </b-button>

                        <b-button v-b-tooltip.hover.top="'Adicionar nova...'" id="novo" class="mr-2 my-2" size="sm"
                            style="height: 20px" pill @click="showForm" variant="primary">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" />
                            </div>
                        </b-button>
                    </b-col>
                </b-row>
                <b-table responsive class="mt-2" show-empty :busy="busy" :items="records" :fields="fields" hover>
                    <template #cell(motivoSolicitacao)="data">
                        {{ data.item.motivoSolicitacao == 0 ? "Reequilíbrio" : (data.item.motivoSolicitacao ==
                            1 ? "Correção" : "Outros") }}

                    </template>

                    <template #cell(dhSolicitacao)="data">
                        {{ formatDate(data.item.dhSolicitacao) }}

                    </template>

                    <template #cell(action)="data">

                        <b-row class='justify-content-end pr-4'>

                            <b-button v-if="data.item.status == 29" class="my-2 mx-1" size="sm" pill variant="primary"
                                @click="showFormAprovacaoView(data.item)">
                                <b-icon v-b-tooltip.hover.top="'Ver Aprovação'" icon="file-earmark-medical" />
                            </b-button>


                            <b-button v-if="data.item.status == 31" class="my-2 mx-1" size="sm" pill variant="primary"
                                @click="showFormAprovacao(data.item)">
                                <b-icon v-b-tooltip.hover.top="'Aprovar'" icon="check-circle" />
                            </b-button>



                            <b-button v-if="data.item.status == 31" class="my-2 mx-1" size="sm" pill variant="danger"
                                @click="rejeitar(data.item)">
                                <b-icon v-b-tooltip.hover.top="'Rejeitar'" icon="x-circle" />
                            </b-button>


                            <b-button class="my-2 mx-1" size="sm" pill variant="primary" @click="visualizar(data.item)">
                                <b-icon v-b-tooltip.hover.top="'Visualizar'" icon="eye" />
                            </b-button>
                        </b-row>

                    </template>

                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                </b-table>
                <b-row style="margin-top: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
        <ConsultarSolicitacaoAlteracaoValorForm :isViewMode="isViewMode" :id="id" @close="fecharForm" :idAta="ata"
            v-if="mostrarForm" :prefix="prefix + title + ' > '"></ConsultarSolicitacaoAlteracaoValorForm>


        <ModalAAprovacaoAtaSolicitacaoAlteracaoValor @close="fecharModalAprovacao" v-if="mostrarFormAprovacao"
            :isViewMode="isViewMode" :prefix="prefix + title + ' > '" :ataSolicitacao="id">
        </ModalAAprovacaoAtaSolicitacaoAlteracaoValor>
    </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import { ListResourceMixin } from "@/core/mixins/resource";
import ConsultarSolicitacaoAlteracaoValorForm from "./ConsultarSolicitacaoAlteracaoValorForm.vue";
import ModalAAprovacaoAtaSolicitacaoAlteracaoValor from "./ModalAAprovacaoAtaSolicitacaoAlteracaoValor.vue";
export default {
    components: {
        ConsultarSolicitacaoAlteracaoValorForm,
        ModalAAprovacaoAtaSolicitacaoAlteracaoValor
    },
    mixins: [ListResourceMixin],

    props: {
        ata: Number,
        prefix: {
            type: String,
            default: ""
        },
        statusId: Number,
        processoId: Number,
        status: {
            type: Number,
            default: null,
        },
        consultaDetalhada: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            id: null,
            mostrarForm: false,
            mostrarFormAprovacao: false,
            isViewMode: false,
            mostrarModalForm: false,
            title: "Consultar Solicitação de Alteração de Valor",
            fields: [
                { key: "motivoSolicitacao", label: "Motivo da Solicitação" },
                { key: "justificativa", label: "Justificativa" },
                { key: "dhSolicitacao", label: "Data de Solicitação" },
                { key: "statusDescricao", label: "Status" },
                { key: "action", label: " " },




            ],
            currentPage: 1,
            perPage: 10,
            totalPages: 1,
            busy: false,
            perPageOptions: [5, 10, 25, 50],
        }
    },
    watch: {
        page() {
            this.load()
        },
    },
    beforeMount() {
        this.$service = new ResourceService(`/api/ata-solicitacao-atualizacao-valor`);

        this.load()
    },
    methods: {
        async rejeitar(item) {

            try {
                await this.$service.put(`rejeitar/${item.cod}`);
                this.$notify({
                    type: "success",
                    message: "Solicitação rejeitada com sucesso"
                });

                this.load();
            }
            catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data
                });

            }
        },
        visualizar(item) {
            this.isViewMode = true;
            this.id = item.cod;
            this.mostrarForm = true;
        },
        formatDate(dateString) {
            if (!dateString) return "N/A"
            const date = new Date(dateString)
            const day = String(date.getDate()).padStart(2, '0')
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const year = date.getFullYear()
            return `${day}/${month}/${year}`
        },

        fecharModalAprovacao() {
            this.id = null;
            this.isViewMode = false;
            this.mostrarFormAprovacao = false;
            this.load();

        },
        showFormAprovacaoView(item) {
            this.id = item.cod;
            this.isViewMode = true;
            this.mostrarFormAprovacao = true;
        },

        showFormAprovacao(item) {
            this.id = item.cod;
            this.isViewMode = false;
            this.mostrarFormAprovacao = true;
        },

        showForm() {
            this.id = null;
            this.isViewMode = false;
            this.mostrarForm = true;
        },

        fecharForm() {
            this.id = null;
            this.isViewMode = false;
            this.mostrarForm = false;
            this.load();
        },
        async load() {
            this.busy = true
            this.filtro = {};

            this.filtro.ata = this.ata;

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,

            });

            this.busy = false;

        },
    },
}
</script>

<style scoped>
.badge {
    font-size: 85% !important;
    padding: 5px 10px !important;
}

.btn-size-alinhamento {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
